import React from "react";
//#region types
import { WintSuperkollAPIModelDeadlines } from "wint-api-client/dist/types";
import { TodoFormTypes } from "models/formTypes";
import { ReportConstants, RouteConstants, TableConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTodoReportFilterDefinition } from "components/todos";
import { DeadlineToDoListView } from "components/deadline";
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, TableContextProvider } from "components/common";
import { DeadlineConsequencesCard, DeadlineReportWidget } from "components/deadline";
import { useTodoService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const DeadlineReport: React.FC = () => {
  const todoService = useTodoService();

  const { filterFormFields: reportFilterDefinition, filterQueryStateHandler } = useTodoReportFilterDefinition(true);
  const [deadline, setDeadline] = React.useState<WintSuperkollAPIModelDeadlines.Deadline>();

  const queryParams = new URLSearchParams(useLocation().search);
  const deadlineId = React.useRef<number>(Number(queryParams.get(RouteConstants.DeadlineQueryParams.DeadlineId) ?? 0));

  React.useEffect(() => {
    if (deadlineId.current > 0) {
      loadDeadline(deadlineId.current);
    } else {
      setDeadline(undefined);
    }
  }, [deadlineId.current]);

  const loadDeadline = (deadlineId: number) => {
    todoService.getDeadlineById(deadlineId).then((res) => {
      setDeadline(res);
    });
  };

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.Todo}
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<TodoFormTypes.Filter>
          entityKey={0}
          title={
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Deadline) +
            (deadline
              ? ` - ${LocalizationHelperInstance.getTranslatedEnumValue("Todos.DeadlineType", deadline.type)}`
              : "")
          }
          topRightButtons={<DashboardButtonGroup buttons={[<FilterButton />]} />}
          filterFields={reportFilterDefinition}
          filterQueryStateHandler={filterQueryStateHandler}
          hasPermissions
        >
          <Grid container spacing={3}>
            {deadline ? (
              <Grid item xs>
                <DeadlineReportWidget deadline={deadline} className={cssExports.deadlineReportWidgetContainer} />
              </Grid>
            ) : (
              <></>
            )}
            {deadline?.consequences?.length ? (
              <Grid item xs={4} className={cssExports.deadlineConsequenceContainer}>
                <DeadlineConsequencesCard consequences={deadline.consequences} />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
          <TableContextProvider tableKey={TableConstants.TodoList}>
            <DeadlineToDoListView reloadKey={reloadKey} reloadTodos={reload} />
          </TableContextProvider>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default DeadlineReport;
